// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".projected-inventory-interval{width:100%}.projected-inventory-interval__table,.projected-inventory-interval__table>.v-data-table__wrapper>table>thead>tr th{background:transparent!important}", ""]);
// Exports
module.exports = exports;
